import { render, staticRenderFns } from "./Autumn.vue?vue&type=template&id=f32c5df2&scoped=true"
import script from "./Autumn.vue?vue&type=script&lang=js"
export * from "./Autumn.vue?vue&type=script&lang=js"
import style0 from "./Autumn.vue?vue&type=style&index=0&id=f32c5df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32c5df2",
  null
  
)

export default component.exports